module.exports = __webpack_public_path__ + "img/1477000464.5b98c987.jpg";